import NextLink from 'next/link';
import { useProductDocuments } from '~/features/product-details/components/ProductOverview/hooks/useProductDocuments';
import Pdf from '~/icons/pdf.svg';
import { Typography } from '~/shared/components';
import styles from './ProductDocumentation.module.scss';

type Props = React.HTMLAttributes<HTMLUListElement>;

export const ProductDocumentation: React.FC<Props> = ({ className, ...rest }) => {
    const documents = useProductDocuments();

    if (!documents.length) return null;

    return (
        <ul className={className} {...rest}>
            {documents.map((document) => (
                <li className={styles.productDocumentationItem} key={document.Path}>
                    <NextLink
                        className={styles.productDocumentationLink}
                        href={document.Path}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Pdf
                            className={styles.productDocumentationIcon}
                            aria-hidden="true"
                            focusable="false"
                        />

                        <Typography
                            className={styles.productDocumentationName}
                            variant="paragraph-S"
                            as="span"
                        >
                            {document.Name ?? document.Path}
                        </Typography>
                    </NextLink>
                </li>
            ))}
        </ul>
    );
};
